// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e40e7eef","455":"f3c29e35","977":"79236cee"}[chunkId] + ".chunk.js";
};